import TabletBox from './TabletBox';

export default TabletBox;
export { TabletBox };
